'use client';

import { motion } from 'framer-motion';

interface TitleProps {
  title: string;
  desc?: string;
}

export default function Title({ title, desc }: TitleProps) {
  return (
    <motion.div
      className="max-w-4xl px-5 text-center !text-white"
      initial={{ opacity: 0, y: -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="relative mb-4 inline-block text-center text-3xl font-bold md:text-4xl">
        {title}
        <motion.div
          className="absolute -bottom-4 left-1/2 h-1 -translate-x-1/2 bg-primary-500"
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: '30%', opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        ></motion.div>
      </h2>
      {desc && (
        <p className="mt-2 text-center font-light text-gray-950 md:text-lg">
          {desc}
        </p>
      )}
    </motion.div>
  );
}
